// extracted by mini-css-extract-plugin
module.exports = {"Main":"SectionInitSelector_Main__vC8zG","Title":"SectionInitSelector_Title__2tFaB","Actions":"SectionInitSelector_Actions__2eDav"};